<template>
  <ToursSection />
</template>

<script>
import ToursSection from '../components/sections/ToursSection.vue'

export default {
  name: 'ZiaratPage',
  components: {
    ToursSection
  }
}
</script>
